import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=0a5a4337&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens-v2.vue?vue&type=style&index=0&id=0a5a4337&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5a4337",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a5a4337')) {
      api.createRecord('0a5a4337', component.options)
    } else {
      api.reload('0a5a4337', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=0a5a4337&scoped=true&", function () {
      api.rerender('0a5a4337', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-270j5iEt9DSqh/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports